export default (dispatch) => ({
  clearActiveTool() {
    dispatch({
      type: 'app/setShowSidebar',
      payload: true,
    });
    dispatch({
      type: 'map/resetWidgetState'
    });
  },
});
